import { Controller, useFormContext } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import { Label } from "abs-ui-components";
import { Input } from "abs-ui-components";
import { preventScientificNotation } from "../../../../../../services/utilities";

const JourneyForm = ({ section, type }) => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	const sanitizeKey = (key) => {
		if (!key) return "";
		return key.replace(/\|/g, "").replace(/\./g, "_");
	};

	return (
		<>
			{(section.sectionName === "Journey Details" ||
				section.sectionName === "onShore Details") && (
					<MDBRow className="mt-4">
						{section?.fields?.map((formField, fieldIndex) => (
							<MDBCol
								md="3"
								className="pr-2 mt-3"
								key={`${formField.key}-${fieldIndex}`}
							>
								{formField.dataType === "decimal" && (
									<>
										<Label
											bold
											name={formField.fieldName}
											className="mb-1"
										/>
										<Controller
											name={
												sanitizeKey(formField.key)
											}
											control={control}
											defaultValue={
												type === "Edit"
													? formField.value || null
													: ""
											}
											render={({ field }) => {
												if (!field) return null;

												return (
													<Input
														autoFocus={false}
														{...field}
														className="inputHeight"
														type="number"
														step="any"
														onChange={(e) => {
															field.onChange(e);
														}}
														value={field?.value ?? ""}
														onKeyDown={(e) => {
															preventScientificNotation(e);
															// Prevent up and down arrow keys
															if (
																e.key === "ArrowUp" ||
																e.key === "ArrowDown"
															) {
																e.preventDefault();
															}
														}}
														onWheel={(e) => e.target.blur()}
													/>
												);
											}}
										/>
									</>
								)}
							</MDBCol>
						))}
					</MDBRow>
				)}
		</>
	);
};

export default JourneyForm;
